module.exports = __webpack_public_path__ + "images/ARLO-7cee32.png";